import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const RegistrationAPI = {
  getAll: function ({ offset, limit, search, status, start, end }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/registrations`,
      params: { offset, limit, search, status, start, end },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getById: function (id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/org-members/${id}`,
    })
  },
  approve: function (id, accept) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/super-admin/org-members/${id}/approve`,
      data: { accept },
    })
  },
  activate: function (id, activate) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/org-members/${id}/activation`,
      data: { activate },
    })
  },
  create: function (data) {
    return axiosInstance.request({
      method: 'POST',
      url: `/super-admin/organizations`,
      data: data,
    })
  },
  updateUserRegister: function (userId, data) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/org-members/${userId}`,
      data: data,
    })
  },
  updateOrgRegister: function (orgId, data) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/super-admin/organizations/${orgId}`,
      data: data,
    })
  },
  resendApprove: function (id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/super-admin/org-members/${id}/resend-approve`,
    })
  },
}

const cancelTokenObject = createCancelToken(RegistrationAPI)
export default RegistrationAPI
